import KeenSlider from "keen-slider";

const sliders = document.getElementsByClassName("keen-slider");
[...sliders].forEach(function (slider) {
	const sliderId = slider.id;
	const sliderElement = document.getElementById(sliderId);
	const prevButton = sliderElement.querySelector(".arrow.arrow--left");
	const nextButton = sliderElement.querySelector(".arrow.arrow--right");
	const autoplaySpeed = parseInt(sliderElement.getAttribute("data-autoplay-speed")) * 1000;
	let {
		view_desktop_large,
		view_desktop,
		viewTablet,
		viewMobile,
		autoplay,
		arrows,
		loopStatus,
		customClass,
	} = sliderElement.dataset;
	const sliderContent = sliderElement.querySelector(".slider-content");
	sliderElement.parentNode.classList.add(customClass);
	sliderContent.removeAttribute("loading");

	let keenSlider;

	// Set 'auto' perView when select the value 1
	// view_desktop_large == 1 ? (view_desktop_large = "auto") : view_desktop_large;
	// view_desktop == 1 ? (view_desktop = "auto") : view_desktop;
	// viewTablet == 1 ? (viewTablet = "auto") : viewTablet;
	// viewMobile == 1 ? (viewMobile = "auto") : viewMobile;

	console.log(loopStatus);

	const breakpoints = {
		"(min-width: 0px)": {
			renderMode: "performance",
			slides: {
				perView: viewMobile,
				spacing: 24,
				origin: 0,
			},
		},
		"(min-width: 580px)": {
			slides: {
				perView: viewTablet,
				spacing: 25,
			},
		},
		"(min-width: 1200px)": {
			initial: 0,
			slides: {
				perView: view_desktop,
				spacing: 28,
			},
		},
		"(min-width: 1380px)": {
			initial: 0,
			slides: {
				perView: view_desktop_large,
				spacing: 28,
			},
		},
	};

	const initializeSlider = function () {
		keenSlider = new KeenSlider(sliderElement, {
			loop: false,
			duration: 1000,
			mode: "free",
			dragSpeed: 1,
			dragStart: function () {
				sliderElement.classList.add("slider--dragging");
			},
			dragEnd: function () {
				sliderElement.classList.remove("slider--dragging");
			},
			breakpoints: breakpoints,
		});

		if (arrows) {
			prevButton?.addEventListener("click", function () {
				keenSlider.prev();
			});

			nextButton?.addEventListener("click", function () {
				keenSlider.next();
			});
		}

		autoplay == true ? startAutoplay() : "";
	};

	const startAutoplay = function () {
		if (autoplaySpeed > 0) {
			keenSlider.interval = setInterval(function () {
				keenSlider.next();
			}, autoplaySpeed);
		}
	};

	const stopAutoplay = function () {
		if (keenSlider.interval) {
			clearInterval(keenSlider.interval);
		}
	};

	initializeSlider();

	sliderElement.addEventListener("mouseover", function () {
		stopAutoplay();
	});

	sliderElement.addEventListener("mouseout", function () {
		autoplay == true ? startAutoplay() : "";
	});
});
